var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 33.8824,
    rx: 4.23529,
    fill: "#EDF3F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4793 13.5189V20.9263C26.4793 21.7848 25.7833 22.4808 24.9248 22.4808H13.1936C12.3351 22.4808 11.6392 21.7848 11.6392 20.9263V12.1924V11.1486C11.6392 10.3244 12.3073 9.65625 13.1315 9.65625H16.2259C16.837 9.65625 17.4141 9.93704 17.7913 10.4178L19.1836 12.1924H25.1528C25.8854 12.1924 26.4793 12.7863 26.4793 13.5189Z",
    fill: "#EDF3F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1836 12.1924H25.1528C25.8854 12.1924 26.4793 12.7863 26.4793 13.5189V20.9263C26.4793 21.7848 25.7833 22.4808 24.9248 22.4808H13.1936C12.3351 22.4808 11.6392 21.7848 11.6392 20.9263L11.6392 12.1924M19.1836 12.1924L17.7913 10.4178C17.4141 9.93704 16.837 9.65625 16.2259 9.65625H13.1315C12.3073 9.65625 11.6392 10.3244 11.6392 11.1486L11.6392 12.1924M19.1836 12.1924H11.6392",
    stroke: "#6F7491",
    strokeWidth: 1.64888
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderClose);
export default __webpack_public_path__ + "static/media/folder-close.8094f6191f627f97c6442e49c23b6c49.svg";
export { ForwardRef as ReactComponent };